module.exports = __webpack_public_path__ + "static/media/th.1903092a.svg";